import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, Fragment as _Fragment } from "vue";
var _hoisted_1 = {
  key: 0,
  "class": "alert alert-primary border-2 align-items-start sh-text-black rounded-4 my-4 d-flex",
  role: "alert"
};
var _hoisted_2 = {
  "class": "me-2 mt-n1",
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "25",
  viewBox: "0 0 24 25",
  fill: "none",
  style: {
    "min-width": "18px",
    "width": "18px"
  }
};
var _hoisted_3 = {
  "class": "flex-grow-1"
};
var _hoisted_4 = {
  "class": "opacity-8 font-size-13"
};
var _hoisted_5 = {
  key: 1,
  "class": "alert alert-warning align-items-start sh-text-black rounded-4 my-4 d-flex",
  role: "alert"
};
var _hoisted_6 = {
  "class": "me-2 mt-n1",
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "25",
  viewBox: "0 0 24 25",
  fill: "none",
  style: {
    "min-width": "18px",
    "width": "18px"
  }
};
var _hoisted_7 = {
  "class": "flex-grow-1"
};
var _hoisted_8 = {
  "class": "opacity-8 font-size-13"
};
var _hoisted_9 = {
  key: 2,
  "class": "alert alert-danger align-items-start sh-text-black rounded-4 my-4 d-flex",
  role: "alert"
};
var _hoisted_10 = {
  "class": "me-2 mt-n1",
  xmlns: "http://www.w3.org/2000/svg",
  version: "1.1",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  width: "24",
  height: "24",
  x: "0",
  y: "0",
  viewBox: "0 0 512 512",
  style: {
    "min-width": "14px",
    "width": "14px"
  }
};
import { performAnalyticsTracking } from '@dashboardApp/helpers/performAnalyticsTracking';
export default {
  __name: 'ThrottleStatus',
  props: {
    status: {
      type: [String, undefined],
      required: true
    }
  },
  setup: function setup(__props) {
    var _performAnalyticsTrac = performAnalyticsTracking(),
      trackEvent = _performAnalyticsTrac.track;
    return function (_ctx, _cache) {
      return _openBlock(), _createElementBlock(_Fragment, null, [__props.status === 'warning' ? (_openBlock(), _createElementBlock("div", _hoisted_1, [(_openBlock(), _createElementBlock("svg", _hoisted_2, _cache[2] || (_cache[2] = [_createElementVNode("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M6.4443 20.5022C8.08879 21.601 10.0222 22.1875 12 22.1875C13.3132 22.1875 14.6136 21.9288 15.8268 21.4263C17.0401 20.9238 18.1425 20.1872 19.0711 19.2586C19.9997 18.33 20.7363 17.2276 21.2388 16.0143C21.7413 14.8011 22 13.5007 22 12.1875C22 10.2097 21.4135 8.2763 20.3147 6.6318C19.2159 4.98731 17.6541 3.70559 15.8268 2.94871C13.9996 2.19183 11.9889 1.9938 10.0491 2.37965C8.10929 2.7655 6.32746 3.71791 4.92894 5.11644C3.53041 6.51496 2.578 8.29679 2.19215 10.2366C1.8063 12.1764 2.00433 14.1871 2.76121 16.0143C3.51809 17.8416 4.79981 19.4034 6.4443 20.5022ZM12.92 8.56766C12.8981 8.63138 12.8679 8.69191 12.83 8.74766L12.71 8.89766C12.5694 9.03641 12.3908 9.13041 12.1968 9.16778C12.0028 9.20516 11.8021 9.18424 11.62 9.10766C11.4988 9.05701 11.3872 8.98599 11.29 8.89766C11.1973 8.80422 11.124 8.6934 11.0742 8.57156C11.0245 8.44972 10.9993 8.31926 11 8.18766C11.0016 8.05698 11.0288 7.92788 11.08 7.80766C11.1249 7.68356 11.1966 7.57086 11.2899 7.47754C11.3832 7.38422 11.4959 7.31257 11.62 7.26765C11.7397 7.21475 11.8691 7.18742 12 7.18742C12.1309 7.18742 12.2603 7.21475 12.38 7.26765C12.5041 7.31257 12.6168 7.38422 12.7101 7.47754C12.8035 7.57086 12.8751 7.68356 12.92 7.80766C12.9713 7.92788 12.9984 8.05698 13 8.18766C13.0049 8.25423 13.0049 8.32108 13 8.38765C12.9828 8.45142 12.9558 8.51214 12.92 8.56766ZM12 17.1877C11.7348 17.1877 11.4804 17.0823 11.2929 16.8948C11.1054 16.7072 11 16.4529 11 16.1877V11.2474C11 10.9822 11.1054 10.7278 11.2929 10.5403C11.4804 10.3528 11.7348 10.2474 12 10.2474C12.2652 10.2474 12.5196 10.3528 12.7071 10.5403C12.8947 10.7278 13 10.9822 13 11.2474V16.1877C13 16.4529 12.8947 16.7072 12.7071 16.8948C12.5196 17.0823 12.2652 17.1877 12 17.1877Z",
        fill: "#1F1F1F"
      }, null, -1)]))), _createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_cache[3] || (_cache[3] = _createElementVNode("div", {
        "class": "mb-3"
      }, "It appears you have used the same template multiple times. Personalizing the message and sharing more information about your business and what you are looking for will lead to better business relationships. Do this now?", -1)), _createElementVNode("a", {
        onClick: _cache[0] || (_cache[0] = function ($event) {
          return _unref(trackEvent)('EmailFirstWarningClickHelp');
        }),
        href: "/blog/how-to-sweet-talk-suppliers-like-an-ecommerce-pro",
        id: "warningHelpLink",
        target: "_blank",
        "class": "link-hover-underline"
      }, "Need Help? Learn how to sweet talk here")])])])) : _createCommentVNode("", true), __props.status === 'danger' ? (_openBlock(), _createElementBlock("div", _hoisted_5, [(_openBlock(), _createElementBlock("svg", _hoisted_6, _cache[4] || (_cache[4] = [_createElementVNode("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M6.4443 20.5022C8.08879 21.601 10.0222 22.1875 12 22.1875C13.3132 22.1875 14.6136 21.9288 15.8268 21.4263C17.0401 20.9238 18.1425 20.1872 19.0711 19.2586C19.9997 18.33 20.7363 17.2276 21.2388 16.0143C21.7413 14.8011 22 13.5007 22 12.1875C22 10.2097 21.4135 8.2763 20.3147 6.6318C19.2159 4.98731 17.6541 3.70559 15.8268 2.94871C13.9996 2.19183 11.9889 1.9938 10.0491 2.37965C8.10929 2.7655 6.32746 3.71791 4.92894 5.11644C3.53041 6.51496 2.578 8.29679 2.19215 10.2366C1.8063 12.1764 2.00433 14.1871 2.76121 16.0143C3.51809 17.8416 4.79981 19.4034 6.4443 20.5022ZM12.92 8.56766C12.8981 8.63138 12.8679 8.69191 12.83 8.74766L12.71 8.89766C12.5694 9.03641 12.3908 9.13041 12.1968 9.16778C12.0028 9.20516 11.8021 9.18424 11.62 9.10766C11.4988 9.05701 11.3872 8.98599 11.29 8.89766C11.1973 8.80422 11.124 8.6934 11.0742 8.57156C11.0245 8.44972 10.9993 8.31926 11 8.18766C11.0016 8.05698 11.0288 7.92788 11.08 7.80766C11.1249 7.68356 11.1966 7.57086 11.2899 7.47754C11.3832 7.38422 11.4959 7.31257 11.62 7.26765C11.7397 7.21475 11.8691 7.18742 12 7.18742C12.1309 7.18742 12.2603 7.21475 12.38 7.26765C12.5041 7.31257 12.6168 7.38422 12.7101 7.47754C12.8035 7.57086 12.8751 7.68356 12.92 7.80766C12.9713 7.92788 12.9984 8.05698 13 8.18766C13.0049 8.25423 13.0049 8.32108 13 8.38765C12.9828 8.45142 12.9558 8.51214 12.92 8.56766ZM12 17.1877C11.7348 17.1877 11.4804 17.0823 11.2929 16.8948C11.1054 16.7072 11 16.4529 11 16.1877V11.2474C11 10.9822 11.1054 10.7278 11.2929 10.5403C11.4804 10.3528 11.7348 10.2474 12 10.2474C12.2652 10.2474 12.5196 10.3528 12.7071 10.5403C12.8947 10.7278 13 10.9822 13 11.2474V16.1877C13 16.4529 12.8947 16.7072 12.7071 16.8948C12.5196 17.0823 12.2652 17.1877 12 17.1877Z",
        fill: "#1F1F1F"
      }, null, -1)]))), _createElementVNode("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, [_cache[5] || (_cache[5] = _createElementVNode("div", {
        "class": "mb-3"
      }, "It appears you have sent the same template email a few times now. We strongly suggest you personalize each message to increase the likelihood of a supplier replying. Do this now?", -1)), _createElementVNode("a", {
        onClick: _cache[1] || (_cache[1] = function ($event) {
          return _unref(trackEvent)('EmailSecondWarningClickHelp');
        }),
        href: "/blog/why-dont-suppliers-reply-to-my-emails-and-how-to-fix-it",
        id: "dangerHelpLink",
        target: "_blank",
        "class": "link-hover-underline"
      }, "Need Help? Learn how to sweet talk here")])])])) : _createCommentVNode("", true), __props.status === 'throttled' ? (_openBlock(), _createElementBlock("div", _hoisted_9, [(_openBlock(), _createElementBlock("svg", _hoisted_10, _cache[6] || (_cache[6] = [_createElementVNode("path", {
        d: "M501.362 383.95 320.497 51.474c-29.059-48.921-99.896-48.986-128.994 0L10.647 383.95c-29.706 49.989 6.259 113.291 64.482 113.291h361.736c58.174 0 94.203-63.251 64.497-113.291zM256 437.241c-16.538 0-30-13.462-30-30s13.462-30 30-30 30 13.462 30 30-13.462 30-30 30zm30-120c0 16.538-13.462 30-30 30s-30-13.462-30-30v-150c0-16.538 13.462-30 30-30s30 13.462 30 30v150z",
        fill: "#000000",
        opacity: "1",
        "data-original": "#000000",
        "class": ""
      }, null, -1)]))), _cache[7] || (_cache[7] = _createElementVNode("div", {
        "class": "flex-grow-1"
      }, [_createElementVNode("div", {
        "class": "opacity-8 font-size-13"
      }, [_createElementVNode("div", {
        "class": ""
      }, [_createTextVNode(" You have reached your limit of canned responses for the day. We recommend that you save suppliers you wish to contact until your limit is reset. You can "), _createElementVNode("a", {
        href: "#",
        "class": "link-hover-underline"
      }, "contact support for more information.")])])], -1))])) : _createCommentVNode("", true)], 64);
    };
  }
};